import { render } from "./AdminAcceptModal.vue?vue&type=template&id=5c53113b"
import script from "./AdminAcceptModal.vue?vue&type=script&lang=js"
export * from "./AdminAcceptModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__